import type { MailboxInfo } from 'owa-client-types';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isAccountFeatureEnabled } from './isFeatureEnabled';

export default function (
    mailboxInfo?: MailboxInfo,
    dontThrowErrorIfNotInitialized?: boolean
): boolean {
    return isAccountFeatureEnabled(
        'fwk-useoutlookgateway-getSchedule',
        mailboxInfo ?? getGlobalSettingsAccountMailboxInfo(),
        dontThrowErrorIfNotInitialized
    );
}
